export { renderRatingItem_unstable as renderRatingItem } from '@fluentui/react-rating';
